import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import BoxWithIcon from "../atoms/ComponentBox/BoxWithIcon";
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from "../lib/axios";
import fetchStatusCounts from "../GlobalFunction/Counts";
import { selectPermissions } from '../redux/permissionsSlice';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const Company = () => {
  const names = [
    "Company Master",
    "Employee",
    "Designation",
    "Employee Type",
    "User Type",
    "User Master",
  ];
  const location = useLocation();
  const navigate = useNavigate();
  const [Counts, setCounts] = useState([]);

  const parentId = 4;

  useEffect(() => {
    const getCounts = async () => {
      const data = await fetchStatusCounts(parentId);
      setCounts(data);
    };

    getCounts();
  }, [parentId]);

  const matchedItem = (moduleName) => {
    const matched = Counts.find(item => item.ModuleName === moduleName);

    return matched;                                                                                     
  };

  const match = matchedItem("Company Master");
  const matchUser = matchedItem("User Master");
  const matchEmployee = matchedItem("Employee Master");
  const matchEmployeeType = matchedItem("Employee Type Master");
  const matchDesignation = matchedItem("Designation Master");
  const matchPromocode = matchedItem("Promocode Master");
  const matchCoupon = matchedItem("Coupon Authority");
  const matchTopUp = matchedItem("Topup Master");
  const matchTransport = matchedItem("Addon1");
  const matchMessPlan = matchedItem("Addon2");
  const matchCouponMst= matchedItem("Coupon Master");
  const matchPayPlan= matchedItem("Payment Plan Master");

  const permissions = useSelector(selectPermissions);

  const handleBoxClick = (path) => {
    navigate(path, { state: { permissions } });
  };

  const hasModulePermission = (moduleName) => {
    const modulePermission = permissions.find(
      permission => permission.ModuleName === moduleName
    );

    if (!modulePermission) return false;

    return (
      modulePermission.AddRec === "1" ||
      modulePermission.EditRec === "1" ||
      modulePermission.DeleteRec === "1" ||
      modulePermission.ViewRec === "1"
    );
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        sx={{
          width: "100%",
          maxWidth: "100%"
        }}
      >
        <Grid item xs={12}>
          <Grid container spacing={1}>
            {hasModulePermission("Company Master") && match && (
              <BoxWithIcon
                totalCount={match.TotalCount}
                activeCount={match.ActiveCount}
                inactiveCount={match.InactiveCount}
                link={{ pathname: "/masters/companytable" }}
                permissions={permissions}
                title="Company Master"
              />
            )}
            {hasModulePermission("User Master") && matchUser && (
              <BoxWithIcon
                totalCount={matchUser.TotalCount}
                activeCount={matchUser.ActiveCount}
                inactiveCount={matchUser.InactiveCount}
                link={{ pathname: "/userMasterTable" }}
                permissions={permissions}
                title="User Master"
              />
            )}
            {hasModulePermission("Employee Master") && matchEmployee && (
              <BoxWithIcon
                totalCount={matchEmployee.TotalCount}
                activeCount={matchEmployee.ActiveCount}
                inactiveCount={matchEmployee.InactiveCount}
                link={{ pathname: "/employeetable" }}
                permissions={permissions}
                title="Employee Master"
              />
            )}
            {hasModulePermission("Employee Type Master") && matchEmployeeType && (
              <BoxWithIcon
                totalCount={matchEmployeeType.TotalCount}
                activeCount={matchEmployeeType.ActiveCount}
                inactiveCount={matchEmployeeType.InactiveCount}
                link={{ pathname: "/employeetypetable" }}
                permissions={permissions}
                title="Employee Type Master"
              />
            )}

            {hasModulePermission("Designation Master") && matchDesignation && (
              <BoxWithIcon
                totalCount={matchDesignation.TotalCount}
                activeCount={matchDesignation.ActiveCount}
                inactiveCount={matchDesignation.InactiveCount}
                link={{ pathname: "/designationtable" }}
                permissions={permissions}
                title="Designation Master"
              />
            )}
            {hasModulePermission("Payment Plan Master") &&  matchPayPlan && (
              <BoxWithIcon
                totalCount={matchPayPlan.TotalCount}
                activeCount={matchPayPlan.ActiveCount}
                inactiveCount={matchPayPlan.InactiveCount}
                link={{ pathname: "/roomPlanTable" }}
                permissions={permissions}
                title="Payment Plan Master"
              />
            )}
            {hasModulePermission("Promocode Master") && matchPromocode && (
              <BoxWithIcon
                totalCount={matchPromocode.TotalCount}
                activeCount={matchPromocode.ActiveCount}
                inactiveCount={matchPromocode.InactiveCount}
                link={{ pathname: "/promotable" }}
                permissions={permissions}
                title="Promocode Master"
              />
            )}
            {hasModulePermission("Coupon Authority") && matchCoupon && (
              <BoxWithIcon
                totalCount={matchCoupon.TotalCount}
                activeCount={matchCoupon.ActiveCount}
                inactiveCount={matchCoupon.InactiveCount}
                link={{ pathname: "/couponAuthorityTable" }}
                permissions={permissions}
                title="Coupon Authority"
              />
            )}
            {hasModulePermission("Coupon Master") && matchCouponMst && (
              <BoxWithIcon
                totalCount={matchCouponMst.TotalCount}
                activeCount={matchCouponMst.ActiveCount}
                inactiveCount={matchCouponMst.InactiveCount}
                link={{ pathname: "/generate-coupon-table" }}
                permissions={permissions}
                title="Coupon Master"
              />
            )}
            {hasModulePermission("Topup Master") && matchTopUp && (
              <BoxWithIcon
                totalCount={matchTopUp.TotalCount}
                activeCount={matchTopUp.ActiveCount}
                inactiveCount={matchTopUp.InactiveCount}
                link={{ pathname: "/Topup_Table" }}
                permissions={permissions}
                title="Topup Master"
              />
            )}
            {hasModulePermission("Addon1") && matchTransport && (
              <BoxWithIcon
                totalCount={matchTransport.TotalCount}
                activeCount={matchTransport.ActiveCount}
                inactiveCount={matchTransport.InactiveCount}
                link={{ pathname: "/transport-plan-table" }}
                permissions={permissions}
                title="Addon1"
              />
            )}
            {hasModulePermission("Addon2") && matchMessPlan && (
              <BoxWithIcon
                totalCount={matchMessPlan.TotalCount}
                activeCount={matchMessPlan.ActiveCount}
                inactiveCount={matchMessPlan.InactiveCount}
                link={{ pathname: "/mess-plan-table" }}
                permissions={permissions}
                title="Addon2"
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Company;

